import React, { useContext, useState } from 'react'

// @mui core components
import { Box, Grid, Typography, Button } from '@mui/material'
import Card from 'atoms/Card'

// Data
import { IntakeContext } from 'context/IntakeContext'
import { selectData } from 'layouts/onboarding'

// Popup
import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

// Debounce
import { useFormDebounce } from 'hooks/useFormDebounce'
import LoadingButton from 'components/LoadingButton'

function SocialSecurity() {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  // add an onSubmit button and call the context function `updateUser`
  // const onSubmit = () => updateUser()
  const onSubmit = async () => {
    await updateUser()
    toast.info('You have successfully updated your Social Security details', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  const [localForm, setLocalForm] = useState({
    estimatedSocialSecurity: intakeState.estimatedSocialSecurity || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }

  const currentlyCollectingSS = intakeState?.alreadyCollectingSocialSecurity

  return (
    <>
      <Box
        pl={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography display="flex" align="left" variant="body2FunHeader">
          Social Security
        </Typography>

        <LoadingButton loading={loading} onClick={onSubmit} />
      </Box>
      <Card>
        <Box component="form" p={3}>
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'alreadyCollectingSocialSecurity',
                label: 'Are you currently collecting Social Security?',
                placeholder: '',
                inputType: 'select',
                value: intakeState.alreadyCollectingSocialSecurity,
                onChange: updateIntakeStateAndSubmit(
                  (alreadyCollectingSocialSecurity) =>
                    updateIntakeStateAtKey({ alreadyCollectingSocialSecurity })
                ),
                options: selectData.yesNo,
              })}
            </Grid>
            {currentlyCollectingSS ? (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'estimatedSocialSecurity',
                  label: 'What is your Monthly Social Security benefit?',
                  placeholder: '$2,400.00',
                  inputType: 'currencyFloat',
                  value: localForm.estimatedSocialSecurity,
                  onChange: (e) => handleChange('estimatedSocialSecurity')(e),
                  onBlur: updateIntakeStateAndSubmit(
                    (estimatedSocialSecurity) =>
                      updateIntakeStateAtKey({ estimatedSocialSecurity })
                  ),
                })}
              </Grid>
            ) : (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'estimatedSocialSecurity',
                  label:
                    'Estimated Social Security benefit at full retirement age',
                  placeholder: '$2,400.00',
                  inputType: 'currencyFloat',
                  value: localForm.estimatedSocialSecurity,
                  onChange: (e) => handleChange('estimatedSocialSecurity')(e),
                  onBlur: updateIntakeStateAndSubmit(
                    (estimatedSocialSecurity) =>
                      updateIntakeStateAtKey({ estimatedSocialSecurity })
                  ),
                })}
              </Grid>
            )}
          </Grid>
        </Box>
      </Card>
    </>
  )
}

export default React.memo(SocialSecurity)
